// extracted by mini-css-extract-plugin
export default {"modalBody":"ModalBody-modalBody-RVK6D","modalScroller":"ModalBody-modalScroller-Oqq2l","innerModalBody":"ModalBody-innerModalBody-XiTXT"};